module.exports = __webpack_public_path__ + "static/media/icon-video.39199a6c.svg";